// @ts-nocheck

import Head from 'react-helmet';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Actions
import ErrorActions from 'app/shared/flux/actions/ErrorActions';
import { FilterActions_handleReduxOnlyFilterChange } from 'app/shared/flux/actions/FilterActions';
import UserSearchActions from 'app/shared/flux/actions/UserSearchActions';
import { fetchCollectionData } from 'app/shared/flux/actions/HomeHubActions';

// Components
import Footer from 'app/shared/modules/Footer';
import HomeHero from 'app/shared/modules/frontpage/HomeHero';
import HomeHub from 'app/shared/modules/HomeHub';
import PopularMfBuildings from 'app/shared/modules/frontpage/PopularMfBuildings';
import PreFooter from 'app/shared/modules/frontpage/PreFooter';
import TopCities from 'app/shared/modules/frontpage/TopCities';
import WebSiteAndOrganization from 'app/shared/modules/json-ld/WebSiteAndOrganization';

// Misc / Utils
import { trackHomepageView } from 'app/client/tracking';
import { emitTrackViewHomepageEvent } from 'app/shared/models/Clickstream/PageViewEvents';
import { registerClientProfilerPage } from 'app/shared/utils/clientProfiler';

const FrontPageContainer = styled.div`
  overflow-y: scroll;
  height: calc(100% - 56px);
`;
class FrontPage extends React.Component {
  constructor(props) {
    super(props);

    trackHomepageView();
    emitTrackViewHomepageEvent();
    registerClientProfilerPage('hotpads-homepage');
  }
  serverRouteWillMount(reactContext) {
    const { store } = reactContext;
    const dispatch = store.dispatch;

    const getRecentSearches = (async () => {
      try {
        const res = await dispatch(UserSearchActions.getRecentSearches());
        const { filter } = res || {};

        if (!filter) {
          return;
        }

        dispatch(FilterActions_handleReduxOnlyFilterChange(filter));
      } catch (error) {
        dispatch(
          ErrorActions.errorHandler({
            error,
            errorLocation: 'component.frontPage.serverRouteWillMount#getRecentSearches',
            errorClass: 'userSearchActions',
          }),
        );
      }
    })();
    const getSavedSearches = dispatch(UserSearchActions.getSavedSearches()).catch((error) => {
      dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.frontPage.serverRouteWillMount#getSavedSearches',
          errorClass: 'userSearchActions',
        }),
      );
    });
    const getCollections = dispatch(fetchCollectionData()).catch((error) => {
      dispatch(
        ErrorActions.errorHandler({
          error,
          errorLocation: 'component.frontPage.serverRouteWillMount#getCollections',
          errorClass: 'homeHubActions',
        }),
      );
    });

    return [getRecentSearches, getSavedSearches, getCollections];
  }
  render() {
    const { hasGeolocation, hasRecentSearch } = this.props;
    return (
      <FrontPageContainer>
        <WebSiteAndOrganization />
        <Head
          link={[
            {
              rel: 'canonical',
              href: 'https://hotpads.com',
            },
          ]}
          meta={[
            {
              name: 'description',
              content:
                'Browse the largest and most trusted apartment and home rental site with our' +
                ' verified listings, fraud protection technology and real-time property updates.',
            },
            { property: 'og:title', content: 'HotPads - Apartments and Houses for Rent' },
            {
              property: 'og:description',
              content:
                'Browse the largest and most trusted apartment and home rental site with our' +
                ' verified listings, fraud protection technology and real-time property updates.',
            },
            { property: 'og:url', content: 'https://hotpads.com' },
            { property: 'og:type', content: 'website' },
            { property: 'og:site_name', content: 'HotPads' },
            {
              property: 'og:image',
              content: 'http://filenet.hotpads.com/images/logos/logo_square.png',
            },
          ]}
          title="HotPads - Go ahead. Rent around. Apartments and Houses for Rent"
        />
        {hasGeolocation || hasRecentSearch ? (
          <HomeHub />
        ) : (
          <>
            <HomeHero />
            <PopularMfBuildings />
            <TopCities />
            <PreFooter />
            <Footer crossbrand />
          </>
        )}
      </FrontPageContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    hasGeolocation: !isEmpty(state.geolocation.area) && state.geolocation.area.resourceId !== 'united-states',
    hasRecentSearch: !isEmpty(state.user.search.recent),
  };
};

export default connect(mapStateToProps)(FrontPage);
